import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@lili/lili-frontend-common';

import Heading from '../../../../generic-components/Heading';
import DigitsContainer from '../../../../generic-components/DigitsContainer';
import Button from '../../../../generic-components/Button';
import { convertToTimeFormat } from '../../../../helpers/currency.helper';

interface ICodeValidationProps {
  mfaDestination: string;
  numberOfDigits: number;
  onFulfill: (mfaCode: string) => void;
  onResendCode: () => void;
  isError: boolean;
  isLoading: boolean;
  timeLeft: number;
}

export const CodeValidationWrapper = (props: ICodeValidationProps) => {
  const { mfaDestination, numberOfDigits, onFulfill, isError, isLoading, timeLeft, onResendCode } = props;
  const { t } = useTranslation();
  return (
    <div className='flex absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 flex-col justify-center px-[40px] py-[40px] rounded-[6px] bg-bw00 fadeIn'>
      <Heading
        title={t('INVITE_ACCOUNTANT.VERIFY_PHONE.MAIN_TITLE')}
        className='font-metricRMedium text-bw08 mb-[6px] leading-[34px] text-[28px] text-left'
      />
      <Heading
        title={`${t('ACCOUNTANT_OB.VERIFY_PHONE.SUB_HEADING')}${mfaDestination}`}
        className='font-metricR text-bw08 text-[16px] mb-[24px] text-left'
      />
      <DigitsContainer
        numOfDigits={numberOfDigits}
        onFulfill={(mfaCode) => onFulfill(mfaCode)}
        isError={isError}
        isLoading={isLoading}
      />

      {!timeLeft && (
        <Button
          onClick={() => onResendCode()}
          className='mt-[14px] w-fit font-metricR text-action03 hover:text-action04'
          title={t('ACCOUNTANT_OB.VERIFY_PHONE.CTA')}
          id='initResend'
        />
      )}
      {!!timeLeft && (
        <div className='flex items-center gap-[4px]'>
          <Heading
            title={t('ACCOUNTANT_OB.VERIFY_PHONE.RESEND_TIMER')}
            className='font-metricR text-[14px] text-bw07'
          />
          <Heading title={convertToTimeFormat(timeLeft)} className='font-metricR text-[14px] text-action03' />
        </div>
      )}
      <div className='flex items-center justify-center text-center w-[370px] mt-[28px]'>
        <Text.H11 className='text-center  text-text-main-tertiary'>{t('VERIFICATION_CODE_PAGE_FOOTER')}</Text.H11>
      </div>
    </div>
  );
};
